import React from "react";
import Reveal from "@/components/Reveal";
import { EVENT, TICKET_DOMAIN, TICKET_URL, OFFICIAL } from "@/data/content";

const DETAILS = [
  { label: "TARIKH", value: EVENT.dateWithDay },
  { label: "MASA", value: EVENT.timeRange },
  { label: "TEMPAT", value: EVENT.venue },
  { label: "LOKASI", value: EVENT.location },
];

export default function Butiran() {
  return (
    <section className="sec sec--butiran" id="butiran" data-testid="section-butiran">
      <div className="pattern pattern--tile" aria-hidden="true" />
      <div className="container">
        <div className="details" data-testid="event-details">
          {DETAILS.map((d, i) => (
            <Reveal variant="up" delay={80 + i * 80} key={d.label}>
              <div className="details__card" data-testid={`event-detail-${i}`}>
                <span className="details__label">{d.label}</span>
                <span className="details__value">{d.value}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal variant="fade" delay={280}>
          <p className="butiran__note" data-testid="butiran-note">
            Semua kategori adalah tempat duduk. Tiket rasmi dijual di{" "}
            <a href={TICKET_URL} target="_blank" rel="noreferrer">
              {TICKET_DOMAIN}
            </a>
            . Caj platform (jika ada) dipaparkan semasa pembayaran.{" "}
            <a href={OFFICIAL.terms} target="_blank" rel="noreferrer" data-testid="butiran-terms-link">
              Terma &amp; Syarat rasmi
            </a>
            .
          </p>
        </Reveal>
      </div>
    </section>
  );
}
